import attendanceReducer from './';

export default attendanceReducer;